export const SizesDevice = {
    MOBILE: 'MOBILE',
    DESKTOP: 'DESKTOP'
} as const;